<template>
  <div id="app">
    <h1 class="text-center display-4 mt-3">Mortgage Calculator</h1>
    <Fields></Fields>
  </div>
</template>

<script>
import Fields from "./components/Fields";

export default {
  name: "app",
  components: {
    Fields
  }
};
</script>

<style></style>
